<div class="modal fade" id="kt_modal_transport_pickup_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Transport Pickup' : 'Add Transport Pickup' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="transportPickupForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Choose Stock -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Choose Stock</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="vehicleSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onVehicleSearchInput($event)"
                  (focus)="onVehicleInputFocus()"
                  (blur)="onVehicleInputBlur()"
                  placeholder="Search vehicles..."
                  autocomplete="off"
                  [disabled]="isEditMode || isVehiclePreSelected"
                />

                <!-- Loading indicator -->
                <div *ngIf="isVehicleSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Dropdown -->
                <div *ngIf="showVehicleDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto;">
                  <div *ngIf="vehicleSearchResults.length === 0 && !isVehicleSearching" class="dropdown-item-text text-muted">
                    No vehicles found
                  </div>
                  <div *ngFor="let vehicle of vehicleSearchResults"
                       class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                       (click)="selectVehicle(vehicle)">
                    <!-- Vehicle Image -->
                    <div class="symbol symbol-40px me-3">
                      <img [src]="getVehicleImageUrl(vehicle)"
                           [alt]="vehicle.name || 'Vehicle'"
                           class="symbol-label"
                           style="object-fit: cover;">
                    </div>

                    <!-- Vehicle Details -->
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ vehicle.name || 'Unknown Vehicle' }}</div>
                      <div class="text-muted fs-7">
                        <span *ngIf="vehicle.company_name">{{ vehicle.company_name }}</span>
                        <span *ngIf="vehicle.company_name && vehicle.year"> • </span>
                        <span *ngIf="vehicle.year">{{ vehicle.year }}</span>
                      </div>
                      <div class="text-muted fs-8" *ngIf="vehicle.car_no">
                        Inventory: {{ vehicle.car_no }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Order Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Order Date</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="order_date"
                [class.is-invalid]="order_date?.invalid && order_date?.touched"
              />
              <div *ngIf="order_date?.invalid && order_date?.touched" class="invalid-feedback">
                <div *ngIf="order_date?.errors?.['required']">Order date is required</div>
              </div>
            </div>

            <!-- Yard In -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Yard In</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="yard_in"
              />
            </div>

            <!-- Out Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Out Date</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="out_date"
              />
            </div>

            <!-- Yard Out -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Yard Out</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="yard_out"
              />
            </div>

            <!-- Pos No -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Pos No</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="pos_no"
                placeholder="Enter pos number"
              />
            </div>

            <!-- Pickup From -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Pickup From</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="pickupFromSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onPickupFromSearchInput($event)"
                  (focus)="onPickupFromInputFocus()"
                  (blur)="onPickupFromInputBlur()"
                  placeholder="Search auction halls..."
                  autocomplete="off"
                />

                <!-- Loading indicator -->
                <div *ngIf="isPickupFromSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Dropdown -->
                <div *ngIf="showPickupFromDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto;">
                  <div *ngIf="pickupFromSearchResults.length === 0 && !isPickupFromSearching" class="dropdown-item-text text-muted">
                    No auction halls found
                  </div>
                  <div *ngFor="let pickupFrom of pickupFromSearchResults"
                       class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                       (click)="selectPickupFrom(pickupFrom)">
                    <!-- Pickup From Details -->
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ pickupFrom.name || pickupFrom.company_name || 'Unknown Auction Hall' }}</div>
                      <div class="text-muted fs-7" *ngIf="pickupFrom.location">
                        {{ pickupFrom.location }}
                      </div>
                      <div class="text-muted fs-8" *ngIf="pickupFrom.address">
                        {{ pickupFrom.address }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Delivered At -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Delivered At</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="deliveredAtSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onDeliveredAtSearchInput($event)"
                  (focus)="onDeliveredAtInputFocus()"
                  (blur)="onDeliveredAtInputBlur()"
                  placeholder="Search delivery locations..."
                  autocomplete="off"
                />

                <!-- Loading indicator -->
                <div *ngIf="isDeliveredAtSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Dropdown -->
                <div *ngIf="showDeliveredAtDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto;">
                  <div *ngIf="deliveredAtSearchResults.length === 0 && !isDeliveredAtSearching" class="dropdown-item-text text-muted">
                    No delivery locations found
                  </div>
                  <div *ngFor="let deliveredAt of deliveredAtSearchResults"
                       class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                       (click)="selectDeliveredAt(deliveredAt)">
                    <!-- Delivered At Details -->
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ deliveredAt.company_name || deliveredAt.delivered_at || 'Unknown Location' }}</div>
                      <div class="text-muted fs-7" *ngIf="deliveredAt.location">
                        {{ deliveredAt.location }}
                      </div>
                      <div class="text-muted fs-8" *ngIf="deliveredAt.address">
                        {{ deliveredAt.address }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Transport Company -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Transport Company</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="vendorSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onVendorSearchInput($event)"
                  (focus)="onVendorInputFocus()"
                  (blur)="onVendorInputBlur()"
                  placeholder="Search transport companies..."
                  autocomplete="off"
                />

                <!-- Loading indicator -->
                <div *ngIf="isVendorSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Dropdown -->
                <div *ngIf="showVendorDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto;">
                  <div *ngIf="vendorSearchResults.length === 0 && !isVendorSearching" class="dropdown-item-text text-muted">
                    No transport companies found
                  </div>
                  <div *ngFor="let vendor of vendorSearchResults"
                       class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                       (click)="selectVendor(vendor)">
                    <!-- Vendor Details -->
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ vendor.company_name || 'Unknown Company' }}</div>
                      <div class="text-muted fs-7" *ngIf="vendor.email">
                        {{ vendor.email }}
                      </div>
                      <div class="text-muted fs-8" *ngIf="vendor.phone">
                        {{ vendor.phone }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Transport Cost -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Transport Cost</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="transport_cost"
                placeholder="Enter transport cost"
                min="0"
              />
            </div>

            <!-- Admin Comment -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Admin Comment</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="admin_comment"
                placeholder="Enter admin comment"
                rows="3"
              ></textarea>
            </div>

            <!-- Comment for transporter -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Comment for transporter</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="comment_for_transporter"
                placeholder="Enter comment for transporter"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update Transport Pickup' : 'Add Transport Pickup' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
